__turbopack_context__.v({
  "socialLink": "ClubSocialLinks-module-scss-module__VvSc1a__socialLink",
  "socialLinks": "ClubSocialLinks-module-scss-module__VvSc1a__socialLinks",
});
